export default __webpack_public_path__ + "static/media/administracion_medicacion_antineoplasica_paciente_pediatrico.1efbf3fa.pdf";